// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICreateExcessContributionFormDto
 */
export interface ICreateExcessContributionFormDto {
    /**
     * 
     * @type {number}
     * @memberof ICreateExcessContributionFormDto
     */
    employee_id: number;
    /**
     * 
     * @type {number}
     * @memberof ICreateExcessContributionFormDto
     */
    account_id: number;
    /**
     * 
     * @type {number}
     * @memberof ICreateExcessContributionFormDto
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof ICreateExcessContributionFormDto
     */
    excess_earnings: number;
    /**
     * 
     * @type {number}
     * @memberof ICreateExcessContributionFormDto
     */
    payment_method_id: number;
    /**
     * 
     * @type {number}
     * @memberof ICreateExcessContributionFormDto
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateExcessContributionFormDto
     */
    file_url?: string;
}

/**
 * Check if a given object implements the ICreateExcessContributionFormDto interface.
 */
export function instanceOfICreateExcessContributionFormDto(value: object): value is ICreateExcessContributionFormDto {
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('account_id' in value) || value['account_id'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('excess_earnings' in value) || value['excess_earnings'] === undefined) return false;
    if (!('payment_method_id' in value) || value['payment_method_id'] === undefined) return false;
    return true;
}

export function ICreateExcessContributionFormDtoFromJSON(json: any): ICreateExcessContributionFormDto {
    return ICreateExcessContributionFormDtoFromJSONTyped(json, false);
}

export function ICreateExcessContributionFormDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateExcessContributionFormDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'],
        'account_id': json['account_id'],
        'amount': json['amount'],
        'excess_earnings': json['excess_earnings'],
        'payment_method_id': json['payment_method_id'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'file_url': json['file_url'] == null ? undefined : json['file_url'],
    };
}

export function ICreateExcessContributionFormDtoToJSON(json: any): ICreateExcessContributionFormDto {
    return ICreateExcessContributionFormDtoToJSONTyped(json, false);
}

export function ICreateExcessContributionFormDtoToJSONTyped(value?: ICreateExcessContributionFormDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'account_id': value['account_id'],
        'amount': value['amount'],
        'excess_earnings': value['excess_earnings'],
        'payment_method_id': value['payment_method_id'],
        'claim_id': value['claim_id'],
        'file_url': value['file_url'],
    };
}

